import React from 'react';
import { LayoutProvider } from 'src/layouts/LayoutContext';
import { Header } from '@features/header/Header';

/**
 * The auth-screen wrapper for the reused branded B2C forms under `/e/*`. Mirror
 * PublicLayout exactly: the branded B2C header (OneHealth logo, logo-only via W2
 * mode) plus a <main> with the same min-height. AuthLayout's maroon Welcome panel
 * is `h-full`, so it needs this stretched parent — otherwise it collapses and the
 * white Welcome text overflows onto the cream page background.
 */
export const W2AuthChrome: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="flex flex-col min-h-screen pt-5 pb-6 gap-6">
    <LayoutProvider>
      <Header />
      <main className="flex justify-between rounded-xl w-full max-w-[1920px] mx-auto px-6 min-h-[calc(100vh-156px)]">
        <div className="w-full">{children}</div>
      </main>
    </LayoutProvider>
  </div>
);
